/* eslint-disable max-len */

import React from 'react';
import type { SVGProps } from 'react';

export interface LockProps extends SVGProps<SVGSVGElement> {
  color?: string;
}

export const Lock: React.FC<LockProps> = ({ color = '#222A34', ...props }) => {
  return (
    <svg width={20} height={21} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M3.6084 11.8089C3.6084 10.4665 3.6084 9.79533 3.86964 9.28261C4.09944 8.83161 4.46611 8.46494 4.91711 8.23515C5.42983 7.9739 6.10101 7.9739 7.44338 7.9739H12.5567C13.8991 7.9739 14.5703 7.9739 15.083 8.23515C15.534 8.46494 15.9006 8.83161 16.1304 9.28261C16.3917 9.79533 16.3917 10.4665 16.3917 11.8089V12.1285C16.3917 14.3476 16.3917 16.0188 16.1304 16.5315C15.9006 16.9825 15.534 17.3492 15.083 17.579C14.5703 17.8403 13.8991 17.8403 12.5567 17.8403H7.44338C6.10101 17.8403 5.42983 17.8403 4.91711 17.579C4.46611 17.3492 4.09944 16.9825 3.86964 16.5315C3.6084 16.0188 3.6084 13.4708 3.6084 12.1285V11.8089Z"
        fill={color}
      />
      <path
        d="M13.9948 7.9739V6.57704C13.9948 4.37078 12.2063 2.58226 10 2.58226C7.79379 2.58226 6.00526 4.37078 6.00526 6.57704V7.9739M7.44338 17.8403H12.5567C13.8991 17.8403 14.5703 17.8403 15.083 17.579C15.534 17.3492 15.9006 16.9825 16.1304 16.5315C16.3917 16.0188 16.3917 14.3476 16.3917 12.1285V11.8089C16.3917 10.4665 16.3917 9.79533 16.1304 9.28261C15.9006 8.83161 15.534 8.46494 15.083 8.23515C14.5703 7.9739 13.8991 7.9739 12.5567 7.9739H7.44338C6.10101 7.9739 5.42983 7.9739 4.91711 8.23515C4.46611 8.46494 4.09944 8.83161 3.86964 9.28261C3.6084 9.79533 3.6084 10.4665 3.6084 11.8089V12.1285C3.6084 13.4708 3.6084 16.0188 3.86964 16.5315C4.09944 16.9825 4.46611 17.3492 4.91711 17.579C5.42983 17.8403 6.10101 17.8403 7.44338 17.8403Z"
        stroke={color}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
